import { render, staticRenderFns } from "./Step3AuthCode.vue?vue&type=template&id=0a7f8e28&scoped=true"
import script from "./Step3AuthCode.vue?vue&type=script&setup=true&lang=js"
export * from "./Step3AuthCode.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Step3AuthCode.vue?vue&type=style&index=0&id=0a7f8e28&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a7f8e28",
  null
  
)

export default component.exports